import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { switchMap, map, catchError } from 'rxjs/operators';

import {
  fetchUserHistoryHomeAction,
  userHistoryHomeAction,
  userHistoryHomeActionError,
} from '@home/store/actions/home.actions';
import { HomeService } from '@home/services/home.service';

@Injectable()
export class HomeEffect {

  constructor(
    private readonly action$: Actions,
    private readonly service: HomeService,
  ) { }

  fetchUserHistoryList$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(fetchUserHistoryHomeAction),
      switchMap(() => {
        return this.service.fetchUserHistoryListByHome()
          .pipe(
            map(response => userHistoryHomeAction({ response: response })),
            catchError((e) => of(userHistoryHomeActionError({ payload: e })))
          );
      })
    ));


}
